import styled, { css } from 'styled-components';
import { gray25, gray90, spacer16, spacer20 } from '@spotify-internal/encore-foundation';

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.dialogConfirmation === 'dark';
};

export default styled.header.withConfig({
  displayName: "Header",
  componentId: "sc-1iu4ehf-0"
})(["padding:", " ", " 0;", ";"], spacer16, spacer20, function (props) {
  return props.hasBorder && css(["border-bottom:1px solid ", ";"], isDarkTheme(props) ? gray25 : gray90);
});